const VIDEO_ID = /^[A-Za-z0-9_-]{11}$/;

/**
 * Extracts the video id from a YouTube link (watch, youtu.be, shorts, embed,
 * live, m./music. hosts) or a bare 11-character id. Null if it isn't one.
 */
export function parseYouTubeId(raw: string): string | null {
  const input = raw.trim();
  if (VIDEO_ID.test(input)) return input;
  try {
    const url = new URL(input.startsWith("http") ? input : `https://${input}`);
    const host = url.hostname.replace(/^(www|m|music)\./, "").toLowerCase();
    let id: string | null = null;
    if (host === "youtu.be") {
      id = url.pathname.split("/")[1] ?? null;
    } else if (host === "youtube.com" || host === "youtube-nocookie.com") {
      const [, kind, rest] = url.pathname.split("/");
      id = kind === "watch" ? url.searchParams.get("v") : ["shorts", "embed", "live", "v"].includes(kind) ? rest : null;
    }
    return id && VIDEO_ID.test(id) ? id : null;
  } catch {
    return null;
  }
}

/** Privacy-enhanced embed URL (no cookies until the viewer presses play). */
export function youTubeEmbedUrl(videoId: string): string {
  return `https://www.youtube-nocookie.com/embed/${videoId}`;
}

export function youTubeWatchUrl(videoId: string): string {
  return `https://youtu.be/${videoId}`;
}
